<template>
  <v-text-field
    v-bind="$attrs"
    v-model="search"
    @keyup.enter="onEnter"
    @input="onInput"
    append-icon="mdi-magnify"
    outlined
  />
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    debounceDelay: {
      type: [Number, String],
      default: 500, // Default debounce delay in milliseconds
    },
    placeholder: {
      type: String,
      default: "Search...",
    },
  },
  data() {
    return {
      search: this.value,
      timeout: null,
    };
  },
  watch: {
    value(newValue) {
      this.search = newValue;
    },
  },
  methods: {
    onInput() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$emit("input", this.search);
      }, this.getDebounceDelay());
    },
    onEnter() {
      clearTimeout(this.timeout);
      this.$emit("input", this.search);
    },
    getDebounceDelay() {
      if (typeof this.debounceDelay === "number") {
        return this.debounceDelay;
      }
      const [amount, unit] = this.debounceDelay.split(/(ms|s)/i);
      const multiplier = unit === "s" ? 1000 : 1;
      return Number(amount) * multiplier;
    },
  },
};
</script>
